var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.favorite()}}},[_c('v-icon',{attrs:{"color":_vm.$store.getters['favorite/isFavorite'](_vm.user.userid) ? 'red' : 'grey'}},[_vm._v("mdi-heart")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }